// extracted by mini-css-extract-plugin
module.exports = {"list":"_63d4766"};